/**
 * src/shell/gm-client/master.ts — 引擎门面单例（单例策略归外壳，引擎 §8）。
 *
 * 接线（全部以 web/src/gm/index.ts 真实签名为准）：
 * - createGameMaster({ store, api })：store = 外壳 SaveStorePort；api 注入 keyProvider
 *   （读 thirdplay:v2:apikey，铁律：Key 只在 apikey.ts 一个家）。
 * - resumeOnBoot()：启动恢复（幂等），错误只 toast 不阻断进桌面。
 */

import { ApiClient, GmError, createGameMaster, type GameMaster } from '../../gm'
import { readApiKey } from '../save/apikey'
import { localSaveStore } from '../save/store'
import { pushToast } from './toast'
import { COPY } from '../copy'

const api = new ApiClient({ keyProvider: () => readApiKey() })

export const gm: GameMaster = createGameMaster({ store: localSaveStore, api })

let resumed = false

/** 启动恢复：只跑一次（StrictMode/重复调用安全） */
export async function resumeOnBoot(): Promise<void> {
  if (resumed) return
  resumed = true
  try {
    const report = await gm.resume()
    if (report.action !== 'none') {
      pushToast(report.message)
    }
  } catch (err) {
    console.error('[shell] 启动恢复失败：', err)
    if (err instanceof GmError) pushToast(`${COPY.shell.errorPrefix}${err.message}`)
    else pushToast(COPY.shell.resumeFail)
  }
}
